import { useQuery } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { DashboardSummary } from '../types';

const QUERY_KEY = 'dashboard-summary';

export const getDashboardSummary = async (yearId?: number): Promise<DashboardSummary> => {
  return axios.get(`/statistic/dashboard`, {
    params: yearId ? { yearId } : undefined,
  });
};

type QueryFnType = typeof getDashboardSummary;

type UseDashboardSummaryOptions = {
  yearId?: number;
  config?: QueryConfig<QueryFnType>;
};

export const useDashboardSummary = ({ yearId, config }: UseDashboardSummaryOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [QUERY_KEY, yearId],
    queryFn: () => getDashboardSummary(yearId),
  });
};
